
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Project } from 'src/app/interfaces/api/project';
import { FlowService } from 'src/app/services/api/flows/flow.service';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { AuthService } from 'src/app/services/core/auth.service';
import { environment } from 'src/environments/environment';
import { SafePipe } from "../../../../pipes/safe.pipe";

@Component({
  selector: 'app-workflows-master',
  templateUrl: './workflows-master.component.html',
  styleUrls: ['./workflows-master.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatSelectModule,
    CommonModule,
    FormsModule,
    SafePipe,
    TranslateModule
  ]
})

export class WorkflowsMasterComponent implements OnInit, OnDestroy {
  flowUrl = environment.FLOW_URL;
  apiUrl = environment.API_URL;
  user: any;
  project: Project = {} as Project;
  database: string = "cad42Users";
  flows: any;
  selectedFlow: any;
  destroy$: Subject<void> = new Subject<void>();

  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private auth: AuthService,
    private flowService: FlowService
  ) {
    this.projectService.currentProject.pipe(takeUntil(this.destroy$)).subscribe(project => {
      if (this.project && this.project.id != project.id) {
        this.project = project;
        this.ngOnInit();
      } else {
        this.project = project;
      }
    })

    this.flows = this.flowService.getCompactFlowsTemplate("cad42Users").pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res) {
        this.flows = res;
        this.flows.sort((a: { createdDate: string | number | Date; }, b: { createdDate: string | number | Date; }) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
        this.selectedFlow = this.flows[0];
        this.changeUrlWorkflows(this.selectedFlow);
      }
    });
  }

  ngOnInit(): void {
    this.user = this.auth.currentUserValue;
    let flowUrl = environment.FLOW_URL;

    if (this.project.services && this.project.services.flowRealtime) {
      flowUrl = this.project.services.flowRealtime;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeUrlWorkflows(flow: any) {
    let startDate: string | null = this.route.snapshot.queryParamMap.get('startDate');
    let endDate: string | null = this.route.snapshot.queryParamMap.get('endDate');

    let dates: string = '';
    if (startDate && endDate) {
      dates = `&startDate=${startDate}&endDate=${endDate}`;
    }

    if (flow.value) {
      this.flowUrl = `${environment.FLOW_URL}/editor?userId=${this.user.id}&projectId=${this.project.id}&database=${this.database}&accessKey=${this.project.accessKey}&flowId=${flow.value.id}&flowName=${flow.value.name}&flowAccessKey=${this.project.flowAccessKey}${dates}`;
    } else {
      this.flowUrl = `${environment.FLOW_URL}/editor?userId=${this.user.id}&projectId=${this.project.id}&database=${this.database}&accessKey=${this.project.accessKey}&flowId=${flow.id}&flowName=${flow.name}&flowAccessKey=${this.project.flowAccessKey}${dates}`;
    }
  }

}
